export enum RemoveFrom {
	Site = 'Site',
	Company = 'Company',
	None = 'None',
}
